import { useMemo } from 'react'

import { PrePushValidationDto } from '@/endpoints/models'
import { useAppContext } from '@/hooks'
import { CheckboxSimpleTable } from '@/pages/User/pages/Settings/pages/TechnicalColumns/Columns'
import {CellValue} from "@/pages/User/pages/Settings/styles";
import { LightTableColumn } from '@/types'

export const useValidationsColumns = () => {
	const { t } = useAppContext()

	return useMemo<LightTableColumn<PrePushValidationDto>[]>(
		() => [
			{
				field: 'path',
				title: t('ELEMENT'),
				width: 140,
			},
			{
				field: 'type',
				title: t('TYPE'),
				width: 50,
			},
			{
				field: 'structureType',
				title: t('ELEMENT_TYPE'),
				width: 50,
			},
			{
				field: 'message',
				title: t('MESSAGE'),
				width: 50,
				formatter: (value) => <div className="overflow-hidden" title={`${value}`}>
					<CellValue>{value}</CellValue>
				</div>
			},
			{
				field: 'allowedIgnore',
				title: t('ALLOWED_IGNORE'),
				width: 50,
				formatter: (_, row) => (
					<CheckboxSimpleTable
						name="allowedIgnore"
						disabled
						initialValue={row.allowedIgnore ?? false}
					/>
				),
			},
			{
				field: 'editableByActualUser',
				title: t('EDITABLE_BY_ACTUAL_USER'),
				width: 50,
				formatter: (_, row) => (
					<CheckboxSimpleTable
						name="editableByActualUser"
						disabled
						initialValue={row.allowedIgnore ?? false}
					/>
				),
			},
		],
		[t],
	)
}
